import "./partners-slider.scss";
import { usePage } from "@inertiajs/react";

export default function PartnersSlider() {
    const { partners } = usePage().props;

    if (!partners || partners.length === 0) {
        return null;
    }

    const items = [...partners, ...partners];

    return (
        <div className="partnersSlider">
            <div className="partnersSlider__track">
                <div className="partnersSlider__track__inner">
                    {items.map((partner, index) => (
                        <div
                            key={`${partner.id}-${index}`}
                            className="partnersSlider__track__inner__slide"
                        >
                            <img
                                src={partner.image}
                                alt={partner.title}
                                loading="lazy"
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
